import { ReactElement } from "react";
import Layout from "../../../components/layout";
import HubCampaigns from "../../../components/Hubs/Campaigns/index";

const HubCampaignPage = (): ReactElement => {
  return (
    <Layout>
      <HubCampaigns />
    </Layout>
  );
};

export default HubCampaignPage;
